import { render, staticRenderFns } from "./OurPrincipals.vue?vue&type=template&id=7f7849d8&scoped=true"
import script from "./OurPrincipals.vue?vue&type=script&lang=js"
export * from "./OurPrincipals.vue?vue&type=script&lang=js"
import style0 from "./OurPrincipals.vue?vue&type=style&index=0&id=7f7849d8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f7849d8",
  null
  
)

export default component.exports